<template>
  <!-- DQ唛头 没有特殊也用这个-->
  <div>
    <div class="main" v-for="(datas, index) in printData" :key="index">
      <div class="content">
        <div class="title"> {{ datas.porder_sn.split('-')[0].substr(datas.porder_sn.split('-')[0].length - 4)
          }}-{{ datas.porder_sn.split('-')[1] }}-{{ datas.number }}</div>
        <div class="top">
          <div class="top-title" :style="{ fontSize: datas.express_no.length > 13 ? '80px' : '100px' }">NO：{{
      datas.express_no
    }}</div>
          <div class="top-text">{{ datas.porder.user.realname }}</div>
          <div class="top-text">CTNO.{{ datas.number_by_express_no }}/{{ datas.count_by_express_no }}</div>
          <p>MADE IN CHINA</p>
        </div>
        <div class="footer">
          <div class="footer-top">
            <div class="left">
              <img src="../../assets/dayindanicon/icon1.png" alt="" />
            </div>
            <div class="right">
              {{ datas.porder_sn }}- {{ datas.number }}
              <div style="font-size: 38px;" v-if="datas.porder.split_from">原单号:{{ datas.porder.split_from }}</div>
              <div style="font-size: 38px;" v-if="datas.porder.from_porder_sn">原单号:{{ datas.porder.from_porder_sn }}
              </div>
              <!-- FBA授权 -->
              <div v-if="datas.porder.is_fba">
                {{ datas.porder.importer.company }}
              </div>

            </div>
          </div>
          <!-- 二维码 -->
          <div class="tiaoxingma">
            <canvas :id="'express_no' + index" style="height:240px" />
          </div>
          <p>{{ datas.express_no }}</p>
          <!-- 重量、箱规 -->
          <div class="weight">
            <span>箱规(cm)：{{ datas.length }}x{{ datas.width }}x{{ datas.height }}</span>
            <span>weight：{{ datas.weight }}KG</span>
          </div>
          <div class="username">
            <span>{{ datas.porder.y_admin.username }}({{ datas.porder.y_admin.realname }}) {{
      datas.porder.p_admin.username }}({{ datas.porder.p_admin.realname }})</span>
            <span>{{ transferDate(new Date()) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { transferDate } from '@/utlis/date'
import { mapState } from 'vuex';
export default {

  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
      }
    )

  },
  data() {
    return {
      transferDate
    };
  },
  created() {
    // this.$nextTick(() => {
    //   this.$print(this.$refs.print)
    // })
  },
  mounted() {
    this.printData.forEach((item, index) => {
      this.getJsBarcode("#express_no" + index, item.express_no);
    })

  },
  methods: {
    print() {
      console.log(this.datas);
      this.$print(this.$refs.print)

    },
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 240,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;
  font-weight: 600 !important;

  div {
    box-sizing: border-box;

  }

  .content {
    width: 1061px;
    height: 1652px;
    border: 8px solid #000000;
    border-top: 0;
    position: relative;
    padding-top: 160px;

    .title {
      position: absolute;
      left: -8px;
      top: 0;
      width: 1061px;
      height: 160px;
      background: #000000;
      text-align: center;
      line-height: 160px;
      font-size: 130px;
      color: #ffffff;
      margin: 0;
    }

    .top {
      height: 546px;
      width: 100%;
      box-sizing: border-box;
      border-bottom: 8px solid #000000;
      padding-top: 80px;
      padding-bottom: 90px;

      .top-title {
        width: 100%;
        text-align: center;
        font-size: 100px;
        color: #000000;
        // margin-top: 115px;
        margin-bottom: 20px;
      }

      .top-text {
        width: 800px;
        margin: auto;
        height: 56px;
        // background: #000000;
        text-align: center;
        font-size: 64px;
        color: #000;
        line-height: 56px;
        margin-bottom: 30px;
      }

      p {
        font-size: 40px;
        text-align: center;
        color: #000000;
      }
    }

    .footer {
      width: 100%;
      padding: 60px 60px 40px 60px;
      height: 900px;
      box-sizing: border-box;

      .footer-top {
        display: flex;
        height: 120px;
        box-sizing: border-box;
        align-items: center;
        position: relative;

        .left {
          img {
            width: 120px;
            height: 120px;
          }
        }

        .right {
          margin-left: 60px;
          font-size: 48px;
          color: #000000;
          width: 680px;
          height: 64px;
          line-height: 64px;
          text-align: center;
        }
      }

      .tiaoxingma {
        height: 240px !important;
        margin: 40px 0;
        overflow: hidden;

        #express_no {
          height: 240px !important;
          width: 100%;
        }

        img {
          height: 240px !important;
        }
      }

      p {
        width: 320px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        margin: auto;
        font-size: 40px;
        color: #000000;
      }

      .weight {
        width: 100%;
        padding: 0 50px;
        position: absolute;
        bottom: 160px;
        left: 0;
        display: flex;
        justify-content: space-between;
        font-size: 50px;
      }

      .username {
        width: 100%;
        height: 48px;
        font-size: 32px;
        display: flex;
        justify-content: space-between;
        font-weight: 400;
        color: #000000;
        margin-top: 230px;
      }
    }
  }
}
</style>
